import { render, staticRenderFns } from "./AgreementPopup.vue?vue&type=template&id=2583c975&scoped=true&"
import script from "./AgreementPopup.vue?vue&type=script&lang=js&"
export * from "./AgreementPopup.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPopup.vue?vue&type=style&index=0&id=2583c975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583c975",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2583c975')) {
      api.createRecord('2583c975', component.options)
    } else {
      api.reload('2583c975', component.options)
    }
    module.hot.accept("./AgreementPopup.vue?vue&type=template&id=2583c975&scoped=true&", function () {
      api.rerender('2583c975', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/popup/AgreementPopup.vue"
export default component.exports